import React from 'react';
import CreatableSelect from 'react-select/lib/Creatable';
// import 'styles/select.scss';

const components = {
  DropdownIndicator: null
};

const createOption = label => ({
  label,
  value: label
});

export default class extends React.Component {
  state = {
    inputValue: ''
  };

  handleChange = (value, actionMeta) => {
    this.props.onChange(value);
  };

  handleInputChange = inputValue => {
    this.setState({ inputValue });
  };

  handleKeyDown = event => {
    const { inputValue } = this.state;
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        this.setState({ inputValue: '' });
        this.props.onChange([...this.props.value, createOption(inputValue)]);
        event.preventDefault();
        break;
      default:
        return;
    }
  };

  render() {
    const { inputValue } = this.state;

    return (
      <CreatableSelect
        {...this.props}
        classNamePrefix="select"
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
      />
    );
  }
}
